<template>
  <div>
    <profile-header :provider="provider" />

    <v-sheet height="100" color="transparent" class="hidden-md-and-up" />

    <v-sheet color="transparent" style="margin-top: 350px; z-index: 1; position: relative">

      <v-layout wrap>

        <v-flex xs12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 my-2>
          <profile-sub-tittle :text="`Galería (${provider.images.length})`" />
          <gallery-carousel :images="provider.images" />
        </v-flex>

        <v-flex v-if="provider.service_items" xs12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 my-2>
          <profile-sub-tittle :text="`Servicio${provider.service_items.length > 0 ? 's' : ''} (${provider.service_items.length})`" />
          <provider-services :services="provider.service_items" />
        </v-flex>

        <v-flex v-if="false" xs12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 my-2>
          <ratings-summary :ratings-summary="provider.ratings_summary" />
        </v-flex>

        <template  v-if="hasOffices">
          <v-flex xs12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 mt-2>
            <profile-sub-tittle :text="`Sucursales (${provider.institution.branch_offices.length})`" />
          </v-flex>

          <v-flex xs12 pa-0 ma-0>
            <branch-offices class="mt-2" :provider="provider"></branch-offices>
          </v-flex>
        </template>

      </v-layout>
    </v-sheet>

  </div>
</template>

<script>
import ProfileHeader from "@/components/providers/profile/ProfileHeader";
import ProfileSubTittle from "@/components/providers/profile/ProfileSubTittle";
import ProviderServices from "@/components/providers/ProviderServices";
import RatingsSummary from "@/components/ratings/RatingsSummary";
import GalleryCarousel from "@/components/providers/profile/GalleryCarousel";
import BranchOffices from "@/components/providers/BranchOffices";
export default {
  name: "ServiceProviderProfile",
  components: {BranchOffices, GalleryCarousel, RatingsSummary, ProviderServices, ProfileSubTittle, ProfileHeader},
  props: {
    provider: {
      type: Object,
      required: true
    }
  },
  computed:{
    hasOffices(){
      const vm = this
      return vm.provider
          && vm.provider.institution
          && vm.provider.institution.branch_offices
          && vm.provider.institution.branch_offices.length > 0
    },
  }
}
</script>

<style scoped>

</style>